import React, { useState } from 'react';
import t from 'prop-types';
import NotaFlotante from './nota-flotante';
import EditorTexto from '../editor/components/editor-texto';

function NotaEditable(_ref) {
  var texto = _ref.texto,
      offset = _ref.offset,
      tamFuenteBase = _ref.tamFuenteBase,
      activo = _ref.activo,
      minX = _ref.minX,
      maxX = _ref.maxX,
      config = _ref.config,
      onActualizar = _ref.onActualizar;

  var _useState = useState(false),
      modoEdicion = _useState[0],
      setModoEdicion = _useState[1];

  function handleActivarEdicion() {
    setModoEdicion(true);
  }

  function handleCancelarEdicion() {
    setModoEdicion(false);
  }

  function handleModificar(textoHtml) {
    setModoEdicion(false);
    onActualizar && onActualizar(texto.id, {
      textoHtml: textoHtml
    });
  }

  function handleMover(x, y) {
    onActualizar && onActualizar(texto.id, {
      x: x,
      y: y
    });
  }

  var x = texto.x,
      y = texto.y,
      textoHtml = texto.textoHtml;

  if (modoEdicion) {
    return React.createElement(EditorTexto, {
      clase: 'edicionNota',
      offset: offset,
      tamFuenteBase: tamFuenteBase,
      x: x,
      y: y,
      textoHtml: textoHtml === config.textoAyuda ? '' : textoHtml,
      textoAyuda: config.textoAyuda,
      onModificar: handleModificar,
      onCancelar: handleCancelarEdicion
    });
  }

  return React.createElement(NotaFlotante, {
    activo: activo,
    x: x,
    y: y,
    minX: minX,
    maxX: maxX,
    offset: offset,
    tamFuenteBase: tamFuenteBase,
    texto: textoHtml,
    onActivarEdicion: handleActivarEdicion,
    onMover: handleMover
  });
}

NotaEditable.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.shape({
    id: t.string.isRequired,
    x: t.number.isRequired,
    y: t.number.isRequired,
    textoHtml: t.string.isRequired
  }).isRequired,

  /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  offset: t.shape({
    x: t.number.isRequired,
    y: t.number.isRequired
  }),

  /** tamaño 'normal' de la fuente en pixels. 1em será tratado como de este tamaño. */
  tamFuenteBase: t.number,

  /** config de herramientas */
  config: t.object.isRequired,

  /** si activo === false, el texto no podra moverse ni modificarse **/
  activo: t.bool,
  minX: t.number,
  maxX: t.number,

  /** 
   * Evento que lanza el componente para informar de los nuevos valores del texto
   * Debe ser una fución con la forma: (textoId, valores) => {...} 
   * 
   * */
  onActualizar: t.func.isRequired
} : {};
export default NotaEditable;